"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllocateBudgetMessageSchema = void 0;
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.AllocateBudgetMessageSchema = (0, core_1.StrictObject)({
    campaign: (0, core_1.StrictObject)({
        id: core_1.IdSchema,
        channelType: ruby_1.ChannelTypeSchema,
    }, {
        title: "Campaign details",
        description: "Details of the campaign considered for budget allocation.",
    }),
    tier: (0, core_1.StrictObject)({
        id: core_1.IdSchema,
    }, {
        title: "Tier details",
        description: "Details of the tier the campaign runs on.",
    }),
    team: (0, core_1.StrictObject)({
        id: core_1.IdSchema,
    }, {
        title: "Team details",
        description: "Details of the team that owns the campaign.",
    }),
}, {
    title: "Budget Allocation Message",
    description: "Message schema for messages sent to the budgetsAllocationWorker queue. Outlining the required parameters to request budget allocation for a campaign.",
});
